import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Section, SectionHeading } from './Shared';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const reduceMotion = useReducedMotion();
  return <Section className="max-w-3xl" data-id="element-54" data-mp="1ccncq8egfjxs">
      <SectionHeading character="問" className="mb-10" data-id="element-55" data-mp="2a2id6o3oeas1">
        LO QUE MÁS NOS PREGUNTAN
      </SectionHeading>
      <div className="space-y-3" data-id="element-56" data-mp="25472kb5k3w8r">
        {faqs.map((faq, index) => {
        const isOpen = index === openIndex;
        return <article key={faq.q} className="paper-card overflow-hidden rounded-sm border border-brand-gold/40" data-id="element-57" data-mp="2065l1uns44ze" data-mpi={index}>
              <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 px-5 py-5 text-left text-sm font-semibold text-brand-ink transition-colors duration-150 ease-out hover:text-brand-cinnabar focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-4px] focus-visible:outline-brand-forest md:px-6 md:text-base" data-id="element-58" data-mp="op5qsthvfg2q">
                <span data-id="element-59" data-mp="1fnc9hwnms22t">{faq.q}</span>
                <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-goldDark transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} data-id="element-60" data-mp="1fqq9iy8tnz73" />
              </button>
              <AnimatePresence initial={false} data-id="element-61" data-mp="rz2txch0gak4">
                {isOpen && <motion.div initial={reduceMotion ? false : {
              opacity: 0,
              height: 0
            }} animate={{
              opacity: 1,
              height: 'auto'
            }} exit={reduceMotion ? undefined : {
              opacity: 0,
              height: 0
            }} transition={{
              duration: 0.2,
              ease: [0.23, 1, 0.32, 1]
            }} data-id="element-62" data-mp="rwyga2tb7x6n">
                    <p className="border-t border-brand-gold/30 bg-brand-surfaceLight/35 px-5 py-5 text-sm leading-relaxed text-brand-text md:px-6 md:text-base" data-id="element-63" data-mp="33mo5bawxf1f3">
                      {faq.a}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </article>;
      })}
      </div>
    </Section>;
}